<template>
  <div>
    <div class="custom-search d-flex justify-content-between mb-2">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Tìm kiếm</label>
          <b-form-input
            v-model="searchTxt"
            placeholder="Tìm kiếm"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <vue-good-table
      mode="remote"
      :columns="fields"
      :rows="tableItems"
      :total-rows="pagination.total"
      :is-loading="tableLoading"
      :pagination-options="{
        enabled: true,
      }"
      :line-numbers="true"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'user'">
          {{ props.row.user.username }}
        </span>
        <span v-else-if="props.column.field === 'money'">
          {{ formatPrice(props.row.money) }}
        </span>

        <span v-else-if="props.column.field === 'totalAmount'">
          {{ formatPrice(props.row.amount) }}
        </span>

        <span v-else-if="props.column.field === 'product'">
          {{ props.row.product.name }}
        </span>

        <span v-else-if="props.column.field === 'profit'">
          <span
            :class="{
              'text-success': props.row.profit > 0,
              'text-danger': props.row.profit < 0,
            }"
            >{{ formatPrice(props.row.profit) }}</span
          >
        </span>

        <span v-else-if="props.column.field === 'createdAt'">
          {{ formatDateTime(props.row.createdAt) }}
        </span>

        <!-- actions  -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
            </b-dropdown>
          </span>
        </span>
        <!-- end actions -->

        <!-- actions  -->
        <span v-else-if="props.column.field === 'win'">
          <div class="d-flex" style="gap: 10px">
            <b-button
              size="sm"
              :variant="props.row.win == 1 ? getBetResultVariant(1) : ''"
              @click="setOrderResult(props.row, 1)"
              >Thắng</b-button
            >
            <b-button
              size="sm"
              :variant="props.row.win == 2 ? getBetResultVariant(2) : ''"
              @click="setOrderResult(props.row, 2)"
              >Thua</b-button
            >
          </div>
        </span>
        <!-- end actions -->

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">Showing 1 to</span>
            <b-form-select
              v-model="pagination.perPage"
              :options="['10', '20', '50']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap">of {{ props.total }} entries</span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pagination.perPage"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>

      <div slot="emptystate" class="text-center">
        Không có dữ liệu để hiển thị.
      </div>

      <div slot="loadingContent">
        <b-spinner variant="primary" />
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BPagination,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BModal,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BBadge,
  VBTooltip,
  BListGroup,
  BListGroupItem,
  BCardText,
} from "bootstrap-vue";

import debounce from "lodash.debounce";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { formatDateTime, formatPrice } from "@/helpers/format";
import LoadingButton from "@/@core/components/loading-button/LoadingButton.vue";
import API from "@/api";
import vSelect from "vue-select";

export default {
  components: {
    BPagination,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
    BModal,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    VueGoodTable,
    BBadge,
    LoadingButton,
    vSelect,
    BListGroup,
    BListGroupItem,
    BCardText,
  },

  data() {
    return {
      fields: [
        // {
        //   field: "id",
        //   label: "Id",
        // },
        {
          field: "user",
          label: "Tên đăng nhập",
        },

        {
          field: "session",
          label: "Phiên",
        },

        {
          field: "choice",
          label: "Đặt",
        },

        {
          field: "totalAmount",
          label: "Số tiền",
        },

        {
          field: "product",
          label: "Loại Game",
        },

        {
          field: "createdAt",
          label: "Thời gian",
        },

        {
          field: "win",
          label: "Đặt kết quả",
        },
      ],

      tableItems: [],
      tableLoading: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
      },
      statusSelected: "0",
      rowSelected: null,
      searchTxt: "",
    };
  },

  computed: {},

  directives: {
    "b-tooltip": VBTooltip,
  },

  methods: {
    formatDateTime,
    formatPrice,

    resetData() {
      this.tableItems = [];
    },
    
    onSearch: debounce(function () {
      this.fetchTableData(1, this.pagination.perPage);
    }, 500),

    onChangeStatus(value) {
      this.fetchTableData(1, this.pagination.perPage);
    },

    fetchTableData(page, size) {
      this.tableLoading = true;
      const params = { page, size: size ? size: this.pagination.perPage };
      if (this.statusSelected !== "all") {
        params.status = this.statusSelected;
      }
      if (this.searchTxt) {
        params.username = this.searchTxt;
      }
      this.$http
        .get(API.ORDER_LIST, { params })
        .then((res) => {
          this.tableItems = res.data;
          this.$set(this.pagination, "total", res.total);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    onPerPageChange({ currentPerPage }) {
      this.fetchTableData(1, currentPerPage);
    },
    onPageChange({ currentPage, currentPerPage }) {
      this.fetchTableData(currentPage, currentPerPage);
    },

    genName(type) {
      if (type === 'small') return 'nhỏ'
      if (type === 'large') return 'lớn'
      if (type === 'double') return 'chẵn'
      if (type === 'single') return 'nhỏ'
      return 123
    },

    async setOrderResult(order, status) {
      try {
        const isTogglingOff = order.win === status;
        const data = {
          isBreak: isTogglingOff ? 0 : status,
          win: isTogglingOff ? 0 : status,
        };
        const res = await this.$http.patch(
          API.ORDER_SET_RESULT + order._id,
          data
        );
        if (res.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập thành công.",
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.$set(order, 'win', res.data.win)
        } else {
          throw res;
        }
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.message || "Lỗi",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
    },

    getStatusText(value) {
      switch (value) {
        case 0:
          return "Đang chờ xử lý";
        case 1:
          return "Hoàn tất";
        case 2:
          return "Hủy";
        default:
          return "N/A";
      }
    },

    getStatusVariant(value) {
      switch (value) {
        case 0:
          return "warning";
        case 1:
          return "success";
        case 2:
          return "danger";
        default:
          return "N/A";
      }
    },

    getBetResultText(profit) {
      if (profit > 0) return "success";
      if (profit < 0) return "danger";
      return "warning";
    },

    getBetResultVariant(win) {
      if (win == 1) return "success";
      if (win == 2) return "danger";
      return "";
    },
  },

  watch: {
    searchTxt(value) {
      this.onSearch();
    },
  },
  created() {
    this.fetchTableData(1, this.pagination.perPage);
  },
};
</script>
